var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoChargeOff(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 56,
    height: 56,
    xmlSpace: "preserve",
    id: "go_charge_off1Canvas",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "go_charge_off1Canvas-lineargradient4-go_charge_freeCanvasgo_charge_occupiedCanvasgo_charge_occupied_origCanvasbezier3",
    x1: 29.72,
    y1: 8.08,
    x2: 37.98,
    y2: 15.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "rgb(234, 238, 248)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "rgb(200, 209, 236)",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "go_charge_off1Canvas-lineargradient4-go_charge_freeCanvasgo_charge_occupiedCanvasgo_charge_occupied_origCanvasbezier5",
    x1: 37.53,
    y1: 14.03,
    x2: 37.14,
    y2: 22.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "rgb(234, 238, 248)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "rgb(200, 209, 236)",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "go_charge_off1Canvas-lineargradient4-go_charge_freeCanvasgo_charge_occupiedCanvasgo_charge_occupied_origCanvasbezier7",
    x1: 37.6,
    y1: 23.15,
    x2: 30.85,
    y2: 28.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "rgb(234, 238, 248)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "rgb(200, 209, 236)",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "go_charge_off1Canvas-lineargradient4-go_charge_freeCanvasgo_charge_occupiedCanvasgo_charge_occupied_origCanvasbezier9",
    x1: 29.47,
    y1: 28.25,
    x2: 20.35,
    y2: 24.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "rgb(234, 238, 248)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "rgb(200, 209, 236)",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "go_charge_off1Canvas-lineargradient4-go_charge_freeCanvasgo_charge_occupiedCanvasgo_charge_occupied_origCanvasbezier11",
    x1: 19.73,
    y1: 24.21,
    x2: 18.75,
    y2: 15.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "rgb(234, 238, 248)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "rgb(200, 209, 236)",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "go_charge_off1Canvas-lineargradient4-go_charge_freeCanvasgo_charge_occupiedCanvasgo_charge_occupied_origCanvasbezier12",
    x1: 19.92,
    y1: 14.41,
    x2: 27.49,
    y2: 7.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "rgb(234, 238, 248)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "rgb(200, 209, 236)",
    stopOpacity: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "go_charge_off1Canvas-go_charge_off1"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "go_charge_off1Canvas-rectangle_5549",
    stroke: "none",
    fill: "rgb(241, 245, 255)",
    x: 0,
    y: 0,
    width: 56,
    height: 56,
    rx: 10
  }), /*#__PURE__*/React.createElement("g", {
    id: "go_charge_off1Canvas-go_charge_freeCanvasgo_charge_occupiedCanvasgo_charge_occupied_origCanvasgroup"
  }, /*#__PURE__*/React.createElement("g", {
    id: "go_charge_off1Canvas-go_charge_freeCanvasgo_charge_occupiedCanvasgo_charge_occupied_origCanvasgroup2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "go_charge_off1Canvas-group4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "go_charge_off1Canvas-go_charge_freeCanvasgo_charge_occupiedCanvasgo_charge_occupied_origCanvasbezier2",
    stroke: "none",
    fill: "rgb(255, 255, 255)",
    d: "M 44,18.91 L 44,18.91 C 44,10.07 36.84,2.91 28,2.91 19.16,2.91 12,10.07 12,18.91 L 12,18.93 C 12,21.79 12.78,24.59 14.25,27.03 L 14.24,27.04 28,53 41.76,27.04 41.75,27.04 41.75,27.03 C 43.22,24.59 44,21.79 44,18.93 L 44,18.91 Z M 44,18.91"
  })), /*#__PURE__*/React.createElement("g", {
    id: "go_charge_off1Canvas-go_charge_freeCanvasgroup"
  }, /*#__PURE__*/React.createElement("path", {
    id: "go_charge_off1Canvas-go_charge_freeCanvasgo_charge_occupiedCanvasgo_charge_occupied_origCanvasbezier3",
    stroke: "none",
    fill: "url(#go_charge_off1Canvas-lineargradient4-go_charge_freeCanvasgo_charge_occupiedCanvasgo_charge_occupied_origCanvasbezier3)",
    d: "M 29.3,9.98 L 29.23,9.97 C 32.81,10.47 35.72,13.1 36.6,16.6 37.42,16.33 38.25,16.05 39.07,15.77 L 39.08,15.8 C 37.91,11.43 34.28,8.16 29.81,7.46 L 29.71,7.44 C 29.01,7.33 28.35,7.81 28.24,8.51 28.23,8.57 28.22,8.63 28.22,8.69 L 28.22,8.69 28.22,8.7 C 28.21,9.33 28.67,9.88 29.3,9.98 L 29.3,9.98 Z M 29.3,9.98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "go_charge_off1Canvas-go_charge_freeCanvasgo_charge_occupiedCanvasgo_charge_occupied_origCanvasbezier5",
    stroke: "none",
    fill: "url(#go_charge_off1Canvas-lineargradient4-go_charge_freeCanvasgo_charge_occupiedCanvasgo_charge_occupied_origCanvasbezier5)",
    d: "M 36.06,23.56 L 36.06,23.56 C 35.83,22.96 36.13,22.29 36.72,22.07 36.85,22.02 36.99,21.99 37.13,21.99 L 37.15,21.99 C 37.8,22.01 38.31,22.56 38.29,23.22 38.28,23.54 38.14,23.84 37.9,24.06 L 37.9,24.06 C 37.92,24.13 37.94,24.19 37.95,24.26 L 37.93,24.3 C 39.73,21.17 39.93,17.36 38.46,14.06 L 38.42,13.96 C 38.12,13.31 37.34,13.03 36.69,13.33 36.64,13.35 36.59,13.38 36.55,13.41 L 36.54,13.41 36.53,13.42 C 35.99,13.75 35.78,14.44 36.04,15.02 L 36.02,14.99 C 37.43,18 36.99,21.55 34.9,24.14 L 34.85,24.19 C 34.94,24.18 35.03,24.17 35.12,24.17 L 35.12,24.17 C 35.31,24.17 35.5,24.21 35.68,24.29 L 35.69,24.3 C 35.72,24.02 35.85,23.76 36.06,23.56 L 36.06,23.56 Z M 36.06,23.56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "go_charge_off1Canvas-go_charge_freeCanvasgo_charge_occupiedCanvasgo_charge_occupied_origCanvasbezier7",
    stroke: "none",
    fill: "url(#go_charge_off1Canvas-lineargradient4-go_charge_freeCanvasgo_charge_occupiedCanvasgo_charge_occupied_origCanvasbezier7)",
    d: "M 35.96,22.48 L 35.99,22.42 C 34.43,25.63 31.1,27.58 27.54,27.4 27.43,28.26 27.45,29.12 27.47,29.98 L 27.42,29.98 C 31.94,30.21 36.18,27.77 38.24,23.73 L 38.29,23.63 C 38.6,22.99 38.34,22.22 37.7,21.91 37.65,21.88 37.59,21.86 37.53,21.84 L 37.53,21.84 37.54,21.84 C 36.94,21.64 36.27,21.9 35.97,22.46 L 35.96,22.48 Z M 35.96,22.48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "go_charge_off1Canvas-go_charge_freeCanvasgo_charge_occupiedCanvasgo_charge_occupied_origCanvasbezier9",
    stroke: "none",
    fill: "url(#go_charge_off1Canvas-lineargradient4-go_charge_freeCanvasgo_charge_occupiedCanvasgo_charge_occupied_origCanvasbezier9)",
    d: "M 29.1,27.34 L 29.09,27.34 C 25.54,27.78 22.08,26.05 20.3,22.96 19.56,23.41 18.84,23.9 18.13,24.38 L 18.15,24.42 C 20.49,28.31 24.9,30.46 29.41,29.91 L 29.4,29.91 C 30.11,29.82 30.62,29.17 30.53,28.46 30.52,28.41 30.51,28.36 30.5,28.31 L 30.5,28.3 30.5,28.31 C 30.35,27.69 29.75,27.27 29.11,27.34 L 29.1,27.34 Z M 29.1,27.34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "go_charge_off1Canvas-go_charge_freeCanvasgo_charge_occupiedCanvasgo_charge_occupied_origCanvasbezier11",
    stroke: "none",
    fill: "url(#go_charge_off1Canvas-lineargradient4-go_charge_freeCanvasgo_charge_occupiedCanvasgo_charge_occupied_origCanvasbezier11)",
    d: "M 20.71,23.61 L 20.74,23.65 C 18.95,21.09 18.66,17.78 19.98,14.95 L 20,14.9 C 19.95,14.88 19.89,14.86 19.84,14.83 L 19.84,14.83 C 19.74,15.36 19.26,15.73 18.73,15.7 L 18.72,15.7 C 18.08,15.69 17.56,15.16 17.57,14.51 17.58,14.3 17.64,14.1 17.74,13.93 17.71,13.89 17.68,13.84 17.65,13.79 L 17.62,13.86 C 15.91,17.52 16.29,21.81 18.6,25.12 L 18.56,25.06 C 18.97,25.65 19.79,25.79 20.38,25.38 20.42,25.35 20.46,25.31 20.5,25.28 L 20.5,25.28 20.5,25.28 C 20.98,24.86 21.07,24.15 20.72,23.62 L 20.71,23.61 Z M 20.71,23.61"
  }), /*#__PURE__*/React.createElement("path", {
    id: "go_charge_off1Canvas-go_charge_freeCanvasgo_charge_occupiedCanvasgo_charge_occupied_origCanvasbezier12",
    stroke: "none",
    fill: "url(#go_charge_off1Canvas-lineargradient4-go_charge_freeCanvasgo_charge_occupiedCanvasgo_charge_occupied_origCanvasbezier12)",
    d: "M 28.09,6.1 L 28.04,6.1 28.03,6.1 C 27.33,6.1 26.77,6.66 26.77,7.36 L 26.78,7.35 C 22.64,7.78 19.07,10.43 17.44,14.26 L 17.43,14.28 C 17.16,14.94 17.46,15.69 18.11,15.97 18.17,15.99 18.24,16.01 18.3,16.03 L 18.3,16.03 18.29,16.03 C 18.91,16.19 19.57,15.88 19.83,15.3 L 19.85,15.25 C 21.06,12.4 23.68,10.38 26.75,9.95 L 26.77,13.94 26.77,13.93 C 26.77,14.63 27.34,15.2 28.04,15.2 L 28.1,15.2 28.1,15.2 C 28.8,15.2 29.37,14.63 29.37,13.93 L 29.37,7.36 29.37,7.35 C 29.36,6.65 28.78,6.09 28.08,6.1 L 28.09,6.1 Z M 28.09,6.1"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoChargeOff);
export default __webpack_public_path__ + "static/media/go_charge_off.39e8f64a3aaf0326dd85cbea0d109e84.svg";
export { ForwardRef as ReactComponent };